import React from 'react';
import { levelTracks } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Levels() {
  return <section id="levels" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-137" data-mp="2waanhx4y24pz">
      <div className="mx-auto max-w-6xl" data-id="element-138" data-mp="2hja1sqf6sebw">
        <SectionHeading eyebrow="Niveles de competencia" title={<>
              Un sistema diseñado para la{' '}
              <span className="text-brand" data-id="element-140" data-mp="28hk97h9kj9cj">realidad de tu colegio</span>
            </>} subtitle="Sabemos que cada institución tiene su propia estructura. Por eso INGLES LISTO abandona las etiquetas rígidas y se organiza por Niveles de Competencia Progresiva: eliges el tomo exacto según el nivel real de tus alumnos." data-id="element-139" data-mp="2mid4i47p28gp" />

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-141" data-mp="3sy73p0wgyy0o">
          {levelTracks.map((track, index) => {
          const isFirst = index === 0;
          return <Reveal key={track.range} delay={index * 0.06} className="h-full" data-id="element-142" data-mp="1q1nk72vczd6" data-mpi={index}>
                <article className={`flex h-full flex-col rounded-3xl border-2 border-ink p-8 sm:p-10 ${isFirst ? 'bg-bone' : 'bg-ink'}`} data-id="element-143" data-mp="22ff775m6wt5j">
                  <p className={`font-display text-sm tracking-[0.16em] ${isFirst ? 'text-brand' : 'text-volt'}`} data-id="element-144" data-mp="2c5rnglmz205v">
                    {track.range}
                  </p>
                  <h3 className={`mt-3 font-display text-3xl leading-none sm:text-4xl ${isFirst ? 'text-ink' : 'text-white'}`} data-id="element-145" data-mp="1jixgmrj2uzav">
                    {track.title}
                  </h3>

                  <ul className="mt-7 grid grid-cols-6 gap-2" data-id="element-146" data-mp="1sgzg32n5xjw1">
                    {track.tomos.map(tomo => <li key={tomo} className={`flex h-14 flex-col items-center justify-center rounded-lg font-display text-lg leading-none ${isFirst ? 'bg-ink text-volt' : 'bg-brand text-white'}`} data-id="element-147" data-mp="33y8tp8jm1hpf">
                        {tomo}
                        <span className="mt-1 font-sans text-[9px] font-bold uppercase tracking-[0.1em] opacity-75" data-id="element-148" data-mp="21kulqymltzjb">
                          Tomo
                        </span>
                      </li>)}
                  </ul>

                  <p className={`mt-7 text-base leading-relaxed ${isFirst ? 'text-ink/70' : 'text-white/70'}`} data-id="element-149" data-mp="2ak7rbg7ly3yr">
                    {track.text}
                  </p>
                </article>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}